import React, {Fragment} from "react";
import AccordionDocFirmato from "./components/AccordionDocFirmato";
import {
    formattaInteroDocVeicolo, getBoolStampaCertificato, getDataFormattata,
    getStrStampaCertificato,
    getStrStampaCertificatoOldBool, TIPO_MARCA_MOTOVEICOLO
} from "../../../utility/common";

export default function DocumentoFirmatoValidoView({
                                                       documento,
                                                       isCertificatoCrsReimm,
                                                       isMotoveicolo,
                                                   }) {

    const veicolo = documento.veicolo;

    function getDichiarazioniAcquisite() {
        if (isCertificatoCrsReimm()) {
            return (
                <AccordionDocFirmato
                    titolo={"Dichiarazioni acquisite"}
                    defaultKey={"14"}
                >
                    <div className={"row text-start"}>
                        <div className={"col-md-12"}>
                            <p>
                                Per il veicolo/complesso di veicoli è stata acquisita:<br/>
                                1) la dichiarazione di recupero e/o ripristino e/o manutenzione e/o verifica di
                                cui
                                all’art.
                                4, comma 2 del Decreto, rilasciata dalla/e seguente/i officina/e:
                            </p>
                            <ul>
                                <li>Denominazione: <strong>{getStrStampaCertificato(veicolo.officina)}</strong>
                                </li>
                                <li>Sede: <strong>{getStrStampaCertificato(veicolo.sede_officina)}</strong></li>
                                <li>Con IVA: <strong>{getStrStampaCertificato(veicolo.iva_officina)}</strong>
                                </li>
                            </ul>
                            {
                                veicolo.officina2 && veicolo.officina2 !== '' &&
                                <div className={"mt-4 mb-4"}>
                                    <ul>
                                        <li>Denominazione: <strong>{getStrStampaCertificato(veicolo.officina2)}</strong>
                                        </li>
                                        <li>Sede: <strong>{getStrStampaCertificato(veicolo.sede_officina2)}</strong>
                                        </li>
                                        <li>Con
                                            IVA: <strong>{getStrStampaCertificato(veicolo.iva_officina2)}</strong>
                                        </li>
                                    </ul>
                                    <strong>(dichiarazione di officina aggiunta
                                        il {getDataFormattata(veicolo.data_dic_officina2)})</strong>
                                </div>
                            }
                            <p>
                                2) la dichiarazione di corretta conservazione del veicolo di cui all’art. 4
                                comma 3 del Decreto:<br/>
                                <strong>{getStrStampaCertificato(veicolo.stato_veicolo_imm || 'Veicolo in buono stato d’uso')}</strong>
                            </p>
                        </div>
                    </div>
                </AccordionDocFirmato>
            );
        } else {
            // Circolanti

            if (veicolo && veicolo.officina && veicolo.officina !== '') {
                return (
                    <AccordionDocFirmato
                        titolo={"Dichiarazioni acquisite"}
                        defaultKey={"13"}
                        colore={"red"}
                    >
                        <div className={"row text-start"}>
                            <div className={"col-md-12"}>
                                <p>
                                    1) La dichiarazione di corretta conservazione e funzionalità del veicolo
                                </p>
                                <p>
                                    2) La dichiarazione di recupero e/o ripristino e/o manutenzione e/o verifica di cui
                                    all’art.
                                    4, comma 2 del Decreto, rilasciata dalla/e seguente/i officina/e:
                                </p>
                                <ul>
                                    <li>Denominazione: <strong>{getStrStampaCertificato(veicolo.officina)}</strong>
                                    </li>
                                    <li>Sede: <strong>{getStrStampaCertificato(veicolo.sede_officina)}</strong></li>
                                    <li>Con IVA: <strong>{getStrStampaCertificato(veicolo.iva_officina)}</strong>
                                    </li>
                                </ul>
                                <p>
                                    3) Fotocopia del libretto di circolazione.
                                </p>
                            </div>
                        </div>
                    </AccordionDocFirmato>
                );
            } else {
                return (
                    <AccordionDocFirmato
                        titolo={"Dichiarazioni acquisite"}
                        defaultKey={"13"}
                        colore={"red"}
                    >
                        <div className={"row text-start"}>
                            <div className={"col-md-12"}>
                                <p>
                                    1) La dichiarazione di corretta conservazione e funzionalità del veicolo
                                </p>
                                <p>
                                    2) Fotocopia del documento della revisione del veicolo
                                    del <strong>{veicolo.data_revisione && veicolo.data_revisione !== '' ? getDataFormattata(veicolo.data_revisione) : '/'}</strong> regolare.
                                </p>
                                <p>
                                    3) Fotocopia del libretto di circolazione con riportata la revisione.
                                </p>
                            </div>
                        </div>
                    </AccordionDocFirmato>
                );
            }
        }
    }

    return (
        <Fragment>
            <div
                className={"text-center"}
                style={{
                    paddingTop: "2rem",
                }}
            >
                <i
                    className="fas fa-check"
                    style={{
                        color: "green",
                        fontSize: "12rem"
                    }}
                />
                <h6 className={"pb-4"}>Certificato autentico</h6>

                <div className={"mt-5 mb-5"}>
                    <div className={"row mt-3"}>
                        <div className={"col-12"}>
                            <h5>
                                Certificato di rilevanza Storica e Collezionistica
                                N° {(veicolo.numero_registrazione + veicolo.suffisso)} del {getDataFormattata(documento.data_ins)}
                            </h5>
                        </div>
                    </div>
                    <hr/>
                    <div className={"row text-start"}>
                        <div className={"col-5"}>
                            <h5>Targa Nazionale precedente/Attuale</h5>
                        </div>
                        <div className={"col-7"}>
                            <h5>{`${veicolo.targa_prec || ''} / ${veicolo.targa || ''}`}</h5>
                        </div>
                    </div>
                    <hr/>
                    <div className={"row text-start"}>
                        <div className={"col-5"}>
                            <h5>Numero Telaio</h5>
                        </div>
                        <div className={"col-7"}>
                            <h5>{veicolo.numero_telaio || ''}</h5>
                        </div>
                    </div>
                    <div className={"row mt-3 text-start"}>
                        <div className={"col-12"}>
                            <p>
                                Il presente certificato identifica il veicolo e non il proprietario
                            </p>
                        </div>
                    </div>
                </div>

                <AccordionDocFirmato
                    titolo={"Dati immatricolazione"}
                    defaultKey={"1"}
                    colore={"red"}
                >
                    <div className={"row text-start"}>
                        <div className={"col-md-12"}>
                            Anno 1°
                            immatricolazione: <strong>{getStrStampaCertificato(veicolo.anno_prima_immatricolazione)}</strong>
                        </div>
                        <div className={"col-md-12"}>
                            Targa precedente nazionale: <strong>{
                            getStrStampaCertificato(veicolo.targa) + (veicolo.targa_prec && veicolo.targa_prec !== '' ? (' già ' + getStrStampaCertificato(veicolo.targa_prec)) : '')
                        }</strong>
                        </div>
                        <div className={"col-md-12"}>
                            Targa precedente
                            estera: <strong>{getStrStampaCertificato(veicolo.targa_estera_prec)}</strong>
                        </div>
                    </div>
                </AccordionDocFirmato>
                <AccordionDocFirmato
                    titolo={"Dati generali"}
                    defaultKey={"2"}
                >
                    <div className={"row text-start"}>
                        <div className={"col-md-12"}>
                            Anno di costruzione: <strong>{getStrStampaCertificato(veicolo.anno)}</strong>
                        </div>
                        <div className={"col-md-12"}>
                            Fabbrica e
                            tipo: <strong>{getStrStampaCertificato(veicolo.marca) + ' ' + getStrStampaCertificato(veicolo.tipo)}</strong>
                        </div>
                        <div className={"col-md-12"}>
                            Omologazione (ove
                            ricorra): <strong>{getStrStampaCertificato(veicolo.omologazione)}</strong>
                        </div>
                        <div className={"col-md-12"}>
                            Carrozzeria: <strong>{getStrStampaCertificato(veicolo.tipo_carrozzeria)}</strong>
                        </div>
                        <div className={"col-md-12"}>
                            Tipo di veicolo: <strong>{(veicolo.tipo_veicolo && veicolo.tipo_veicolo !== '')
                            ? getStrStampaCertificato(veicolo.tipo_veicolo)
                            : (veicolo.id_tipo_marca == TIPO_MARCA_MOTOVEICOLO ? 'motociclo' : 'autovettura')}</strong>
                        </div>
                        <div className={"col-md-12"}>
                            Categoria (art. 47, C.d.S.): <strong>{getStrStampaCertificato(veicolo.categoria)}</strong>
                        </div>
                    </div>
                </AccordionDocFirmato>
                <AccordionDocFirmato
                    titolo={"Dati identificativi"}
                    defaultKey={"3"}
                    colore={"red"}
                >
                    <div className={"row text-start"}>
                        {
                            isCertificatoCrsReimm() ?
                                <div className={"col-md-12"}>
                                    Numero telaio e relativa
                                    posizione: <strong>{`${getStrStampaCertificato(veicolo.numero_telaio)} ${veicolo.posizione_telaio || ''}`}</strong>
                                </div>
                                :
                                <div className={"col-md-12"}>
                                    Numero telaio: <strong>{getStrStampaCertificato(veicolo.numero_telaio)}</strong>
                                </div>
                        }
                        <div className={"col-md-12"}>
                            Targhetta identificativa
                            originaria: <strong>{getStrStampaCertificato(veicolo.targhetta_identificativa)}</strong>
                        </div>
                    </div>
                </AccordionDocFirmato>
                <AccordionDocFirmato
                    titolo={"Dati motore"}
                    defaultKey={"4"}
                >
                    <div className={"row text-start"}>
                        <div
                            className={"col-md-12"}>Tipo: <strong>{getStrStampaCertificato(veicolo.tipo_motore)}</strong>
                        </div>
                        {
                            !isMotoveicolo &&
                            <div
                                className={"col-md-12"}>Posizione: <strong>{getStrStampaCertificato(veicolo.posizione_motore)}</strong>
                            </div>
                        }
                        {
                            isMotoveicolo &&
                            <div
                                className={"col-md-12"}>Numero: <strong>{getStrStampaCertificato(veicolo.numero_motore)}</strong>
                            </div>
                        }
                        <div className={"col-md-12"}>Tempi e
                            combustione: <strong>{`${veicolo.tempi && veicolo.tempi !== '' ? `${veicolo.tempi} tempi` : '/'} ${getStrStampaCertificato(veicolo.alimentazione)}`}</strong>
                        </div>
                        <div className={"col-md-12"}>Numero
                            cilindri: <strong>{getStrStampaCertificato(veicolo.cilindri)}</strong></div>
                        <div className={"col-md-12"}>Cilindrata totale
                            (cc): <strong>{formattaInteroDocVeicolo(veicolo.cilindrata)}</strong></div>
                        {
                            isCertificatoCrsReimm() &&
                            <div className={"col-md-12"}>Alesaggio/diametro
                                (mm): <strong>{formattaInteroDocVeicolo(veicolo.alesaggio)}</strong></div>
                        }
                        {
                            isCertificatoCrsReimm() &&
                            <div className={"col-md-12"}>Corsa
                                (mm): <strong>{formattaInteroDocVeicolo(veicolo.corsa)}</strong></div>
                        }
                        <div className={"col-md-12"}>Potenza massima (kw o
                            CV): <strong>{formattaInteroDocVeicolo(veicolo.potenza)
                                + (veicolo.um_potenza ? (veicolo.um_potenza == '1' ? ' CV' : ' KW') : '')}</strong>{veicolo.potenza_giri_motore && veicolo.potenza_giri_motore !== '' ?
                                <Fragment> a <strong>{formattaInteroDocVeicolo(veicolo.potenza_giri_motore)}</strong> g/m</Fragment> : ''}
                        </div>
                        <div className={"col-md-12"}>Velocità massima
                            (km/h): <strong>{formattaInteroDocVeicolo(veicolo.velocita)}</strong></div>
                    </div>
                </AccordionDocFirmato>
                <AccordionDocFirmato
                    titolo={"Trasmissione"}
                    defaultKey={"5"}
                    colore={"red"}
                >
                    <div className={"row text-start"}>
                        {
                            (!isCertificatoCrsReimm() || !isMotoveicolo) &&
                            <div className={"col-md-12"}>Tipo di
                                trazione: <strong>{getStrStampaCertificato(veicolo.tipo_trazione)}</strong></div>
                        }
                        {
                            isCertificatoCrsReimm() &&
                            <div className={"col-md-12"}>Tipo
                                di
                                trasmissione: <strong>{getStrStampaCertificato(veicolo.tipo_trasmissione)}</strong>
                            </div>
                        }
                        {
                            isCertificatoCrsReimm() &&
                            <div className={"col-md-12"}>Numero assi
                                motore: <strong>{getStrStampaCertificato(veicolo.numero_assi_motore)}</strong></div>
                        }
                        <div className={"col-md-12"}>Tipo
                            cambio: <strong>{getStrStampaCertificato(veicolo.tipo_cambio)}</strong></div>
                        {
                            isCertificatoCrsReimm() &&
                            <div className={"col-md-12"}>Numero
                                rapporti: <strong>{getStrStampaCertificato(veicolo.numero_rapporti)}</strong></div>
                        }
                        {
                            isCertificatoCrsReimm() &&
                            <div className={"col-md-12"}>Rapporto
                                totale: <strong>{getStrStampaCertificato(veicolo.rapporto_tot)}</strong></div>
                        }
                        <div
                            className={"col-md-12"}>Frizione: <strong>{getStrStampaCertificato(veicolo.tipo_frizione)}</strong>
                        </div>
                    </div>
                </AccordionDocFirmato>
                <AccordionDocFirmato
                    titolo={"Freni"}
                    defaultKey={"6"}
                >
                    <div className={"row text-start"}>
                        <div className={"col-md-12"}>Freno di
                            servizio: <strong>{getStrStampaCertificato(veicolo.freno_servizio)}</strong></div>
                        <div className={"col-md-12"}>Freno di
                            soccorso: <strong>{getStrStampaCertificatoOldBool(veicolo.freno_soccorso)}</strong>
                        </div>
                        <div className={"col-md-12"}>Freno di
                            stazionamento: <strong>{getStrStampaCertificato(veicolo.tipo_freno_stazionamento)}</strong>
                        </div>
                        {
                            isCertificatoCrsReimm() &&
                            <div className={"col-md-12"}>Freno
                                motore: <strong>{getStrStampaCertificato(veicolo.freno_motore)}</strong></div>
                        }
                        {
                            isCertificatoCrsReimm() &&
                            <div
                                className={"col-md-12"}>Rallentatore: <strong>{getStrStampaCertificato(veicolo.rallentatore)}</strong>
                            </div>
                        }
                    </div>
                </AccordionDocFirmato>
                <AccordionDocFirmato
                    titolo={"Masse e Dimensioni"}
                    defaultKey={"7"}
                    colore={"red"}
                >
                    <div className={"row text-start"}>
                        <div className={"col-md-12"}>Massa complessiva (peso totale)
                            Kg: <strong>{formattaInteroDocVeicolo(veicolo.massa)}</strong></div>
                        <div className={"col-md-12"}>Tara Kg: <strong>{formattaInteroDocVeicolo(veicolo.tara)}</strong>
                        </div>
                        <div className={"col-md-12"}>Massa rimorchiabile
                            Kg: <strong>{formattaInteroDocVeicolo(veicolo.massa_rim)}</strong></div>
                        {
                            isCertificatoCrsReimm() &&
                            <div className={"col-md-12"}>Massa massima 1°
                                asse: <strong>{veicolo.massa_max_1asse ? formattaInteroDocVeicolo(veicolo.massa_max_1asse) : 'Solo per autocarri'}</strong>
                            </div>
                        }
                        {
                            isCertificatoCrsReimm() &&
                            <div className={"col-md-12"}>Massa massima 2°
                                asse: <strong>{veicolo.massa_max_2asse ? formattaInteroDocVeicolo(veicolo.massa_max_2asse) : 'Solo per autocarri'}</strong>
                            </div>
                        }
                        {
                            isCertificatoCrsReimm() &&
                            <div className={"col-md-12"}>Massa massima enn.mo
                                asse: <strong>{veicolo.massa_max_n_asse ? formattaInteroDocVeicolo(veicolo.massa_max_n_asse) : 'Solo per autocarri'}</strong>
                            </div>
                        }
                        <div className={"col-md-12"}>Lunghezza massima
                            mm: <strong>{formattaInteroDocVeicolo(veicolo.lunghezza)}</strong>
                        </div>
                        <div className={"col-md-12"}>Larghezza massima
                            mm: <strong>{formattaInteroDocVeicolo(veicolo.larghezza)}</strong>
                        </div>
                        {
                            isCertificatoCrsReimm() &&
                            <div className={"col-md-12"}>Altezza massima
                                mm: <strong>{formattaInteroDocVeicolo(veicolo.altezza)}</strong>
                            </div>
                        }
                        <div className={"col-md-12"}>Numero
                            assi: <strong>{formattaInteroDocVeicolo(veicolo.numero_assi)}</strong></div>
                        {
                            isCertificatoCrsReimm() &&
                            <div className={"col-md-12"}>Interasse(i)
                                mm: <strong>{formattaInteroDocVeicolo(veicolo.interasse)}</strong></div>
                        }
                        {
                            isCertificatoCrsReimm() &&
                            <div className={"col-md-12"}>Sbalzo anteriore
                                mm: <strong>{formattaInteroDocVeicolo(veicolo.sbalzo_ant)}</strong>
                            </div>
                        }
                        {
                            isCertificatoCrsReimm() &&
                            <div className={"col-md-12"}>Sbalzo posteriore
                                mm: <strong>{formattaInteroDocVeicolo(veicolo.sbalzo_post)}</strong></div>
                        }
                        {
                            isCertificatoCrsReimm() &&
                            <div className={"col-md-12"}>Carreggiata anteriore
                                mm: <strong>{formattaInteroDocVeicolo(veicolo.carreggiata_asse_ant)}</strong></div>
                        }
                        {
                            isCertificatoCrsReimm() &&
                            <div className={"col-md-12"}>Carreggiata posteriore
                                mm: <strong>{formattaInteroDocVeicolo(veicolo.carreggiata_asse_post)}</strong></div>
                        }
                    </div>
                </AccordionDocFirmato>
                <AccordionDocFirmato
                    titolo={"Pneumatici e sospensioni"}
                    defaultKey={"8"}
                >
                    <div className={"row text-start"}>
                        <div className={"col-md-12"}>Misure
                            pneumatici: <strong>{`ant. ${formattaInteroDocVeicolo(veicolo.misura_pneumatici_ant)} e post: ${formattaInteroDocVeicolo(veicolo.misura_pneumatici_post)}${veicolo.altri_pneumatici && veicolo.altri_pneumatici !== '' ? ` oppure ${formattaInteroDocVeicolo(veicolo.altri_pneumatici)}` : ''}`}</strong>
                        </div>
                        <div className={"col-md-12"}>Sospensioni
                            anteriori: <strong>{getStrStampaCertificato(veicolo.tipo_sosp_ant)}</strong></div>
                        <div className={"col-md-12"}>Sospensioni
                            posteriori: <strong>{getStrStampaCertificato(veicolo.tipo_sosp_post)}</strong></div>
                    </div>
                </AccordionDocFirmato>
                <AccordionDocFirmato
                    titolo={"Dati carrozzeria"}
                    defaultKey={"9"}
                    colore={"red"}
                >
                    <div className={"row text-start"}>
                        <div className={"col-md-12"}>Numero
                            porte: <strong>{formattaInteroDocVeicolo(veicolo.num_porte)}</strong></div>
                        <div className={"col-md-12"}>Posti
                            anteriori: <strong>{formattaInteroDocVeicolo(veicolo.num_posti_ant)}</strong></div>
                        <div className={"col-md-12"}>Posti
                            totali: <strong>{formattaInteroDocVeicolo(veicolo.num_posti_tot)}</strong></div>
                        {
                            isCertificatoCrsReimm() &&
                            <div className={"col-md-12"}>Posto di
                                guida: <strong>{getStrStampaCertificato(veicolo.posto_guida)}</strong></div>
                        }
                    </div>
                </AccordionDocFirmato>
                <AccordionDocFirmato
                    titolo={"Disp. segnalazione visiva"}
                    defaultKey={"10"}
                >
                    <div className={"row text-start"}>
                        {
                            isCertificatoCrsReimm() &&
                            <div className={"col-md-12"}>Proiettore
                                abbagliante: <strong>{getBoolStampaCertificato(veicolo.proiett_abbagliante)}</strong>
                            </div>
                        }
                        {
                            isCertificatoCrsReimm() &&
                            <div className={"col-md-12"}>Proiettore
                                anabbagliante: <strong>{getBoolStampaCertificato(veicolo.proiett_anabagliante)}</strong>
                            </div>
                        }
                        {
                            isCertificatoCrsReimm() &&
                            <div className={"col-md-12"}>Proiettore fendinebbia
                                anteriore: <strong>{getBoolStampaCertificato(veicolo.fendinebbia_ant)}</strong></div>
                        }
                        {
                            isCertificatoCrsReimm() &&
                            <div className={"col-md-12"}>Luce di posizione
                                anteriore: <strong>{getBoolStampaCertificato(veicolo.luce_pos_ant)}</strong></div>
                        }
                        {
                            isCertificatoCrsReimm() &&
                            <div className={"col-md-12"}>Luce di posizione
                                laterale: <strong>{getBoolStampaCertificato(veicolo.luce_pos_lat)}</strong></div>
                        }
                        {
                            isCertificatoCrsReimm() &&
                            <div className={"col-md-12"}>Indicatore di direzione
                                anteriore: <strong>{getBoolStampaCertificato(veicolo.ind_dir_ant)}</strong></div>
                        }
                        {
                            isCertificatoCrsReimm() &&
                            <div className={"col-md-12"}>Indicatore di direzione
                                laterale: <strong>{getBoolStampaCertificato(veicolo.ind_dir_lat)}</strong></div>
                        }
                        {
                            isCertificatoCrsReimm() &&
                            <div className={"col-md-12"}>Indicatore di direzione
                                posteriore: <strong>{getBoolStampaCertificato(veicolo.ind_dir_post)}</strong></div>
                        }
                        {
                            isCertificatoCrsReimm() &&
                            <div className={"col-md-12"}>Luce di posizione
                                posteriore: <strong>{getBoolStampaCertificato(veicolo.luce_pos_post)}</strong></div>
                        }
                        {
                            isCertificatoCrsReimm() &&
                            <div className={"col-md-12"}>Luce di
                                arresto: <strong>{getBoolStampaCertificato(veicolo.luce_arresto)}</strong>
                            </div>
                        }
                        {
                            isCertificatoCrsReimm() &&
                            <div className={"col-md-12"}>Catadiottro
                                posteriore: <strong>{getBoolStampaCertificato(veicolo.catadiottro_post)}</strong>
                            </div>
                        }
                        {
                            isCertificatoCrsReimm() &&
                            <div className={"col-md-12"}>Proiettore per la
                                retromarcia: <strong>{getBoolStampaCertificato(veicolo.proiettore_retromarcia)}</strong>
                            </div>
                        }
                        {
                            isCertificatoCrsReimm() &&
                            <div className={"col-md-12"}>Proiettore fendinebbia
                                posteriore: <strong>{getBoolStampaCertificato(veicolo.fendinebbia_post)}</strong>
                            </div>
                        }
                        {
                            isCertificatoCrsReimm() &&
                            <div className={"col-md-12"}>Luce di ingombro
                                anteriore: <strong>{getBoolStampaCertificato(veicolo.luce_ingombro_ant)}</strong>
                            </div>
                        }
                        {
                            isCertificatoCrsReimm() &&
                            <div className={"col-md-12"}>Luce di ingombro
                                posteriore: <strong>{getBoolStampaCertificato(veicolo.luce_ingombro_post)}</strong>
                            </div>
                        }
                        {
                            isCertificatoCrsReimm() &&
                            <div className={"col-md-12"}>Catadiottro
                                laterale: <strong>{getBoolStampaCertificato(veicolo.catadiottro_lat)}</strong></div>
                        }
                        {
                            isCertificatoCrsReimm() &&
                            <div className={"col-md-12"}>Dispositivo di illuminazione
                                targa: <strong>{getBoolStampaCertificato(veicolo.disp_illum_targa)}</strong></div>
                        }
                        {
                            !isCertificatoCrsReimm() &&
                            <div
                                className={"col-md-12"}>Regolamentari: <strong>{getBoolStampaCertificato(veicolo.disp_illuminazione_ok)}</strong>
                            </div>
                        }
                    </div>
                </AccordionDocFirmato>
                <AccordionDocFirmato
                    titolo={"Vetri"}
                    defaultKey={"11"}
                    colore={"red"}
                >
                    <div className={"row text-start"}>
                        {
                            isCertificatoCrsReimm() &&
                            <div
                                className={"col-md-12"}>Parabrezza: <strong>{getStrStampaCertificato(veicolo.parabrezza)}</strong>
                            </div>
                        }
                        {
                            isCertificatoCrsReimm() &&
                            <div className={"col-md-12"}>Vetri
                                laterali: <strong>{getStrStampaCertificato(veicolo.vetri_lat)}</strong></div>
                        }
                        {
                            isCertificatoCrsReimm() &&
                            <div className={"col-md-12"}>Lunotto
                                posteriore: <strong>{getStrStampaCertificato(veicolo.lunotto_post)}</strong>
                            </div>
                        }
                        <div className={"col-md-12"}>Retrovisore
                            interno: <strong>{getBoolStampaCertificato(veicolo.retrovisore_interno)}</strong>
                        </div>
                        <div className={"col-md-12"}>Retrovisore lato
                            sinistro: <strong>{getBoolStampaCertificato(veicolo.retrovisore_sx)}</strong></div>
                        <div className={"col-md-12"}>Retrovisore lato
                            destro: <strong>{getBoolStampaCertificato(veicolo.retrovisore_dx)}</strong></div>
                    </div>
                </AccordionDocFirmato>
                <AccordionDocFirmato
                    titolo={"Altro"}
                    defaultKey={"12"}
                >
                    <div className={"row text-start"}>
                        <div
                            className={"col-md-12"}>Dispositivo
                            silenziatore: <strong>{getBoolStampaCertificato(veicolo.disp_sil_legge)}</strong>
                        </div>
                        <div
                            className={"col-md-12"}>Organi di
                            traino: <strong>{getBoolStampaCertificato(veicolo.disp_sil_org_traino)}</strong>
                        </div>
                    </div>
                </AccordionDocFirmato>
                {
                    isCertificatoCrsReimm() &&
                    <AccordionDocFirmato
                        titolo={"Parti sostituite"}
                        defaultKey={"13"}
                        colore={"red"}
                    >
                        <div className={"row text-start"}>
                            <div
                                className={"col-md-12"}>Parti del veicolo sostituite non conformi a quelle
                                originarie:&nbsp;
                                <strong>{veicolo.parti_sostituite && veicolo.parti_sostituite.trim() !== '' ? veicolo.parti_sostituite : 'Nessuna.'}</strong>
                            </div>
                        </div>
                    </AccordionDocFirmato>
                }
                {
                    getDichiarazioniAcquisite()
                }
            </div>
        </Fragment>
    );
}